/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/typedef */
/* eslint-disable no-console */
/* eslint-disable @angular-eslint/no-empty-lifecycle-method */
/* eslint-disable @typescript-eslint/no-empty-function */
import { Component, OnInit } from '@angular/core';
import { LanguageService } from '../services/language.service';
import { TranslationService } from '../services/translation.service';


@Component({
  selector: 'app-custom-footer',
  templateUrl: './custom-footer.component.html',
  styleUrls: ['./custom-footer.component.scss']
})
export class CustomFooterComponent implements OnInit {
  public links: { name: string, url: string }[] = [];

  constructor(
    private languageService: LanguageService,
    private translationService: TranslationService
  ) {}

  public get CurrentLanguage(): string {
    return this.languageService.GetLanguage();
  }

  public GetPageLink(locale: string): string {
    const page = { locale: locale, key: null }; 
    const routeMap = {};
    const lang = this.CurrentLanguage; 

    const pageLink = this.languageService.GetPageLink(page, lang, routeMap);

    return pageLink;
  }

  public LoadTranslationData(): void {
    const lang = this.CurrentLanguage;

    this.translationService.getTranslation(lang).subscribe(data => {
      this.links = data.ukgc.customFooter.siteMapNames.links;
    });
  }

  ngOnInit(): void {
    this.LoadTranslationData();
  }
}